import React from 'react';
import { connect } from 'react-redux';
import { NavLink } from 'react-router-dom';
import { Typography, Button } from '@mui/material';
import classnames from 'classnames';

export class LogoBanner extends React.Component {
  render() {
    const { site, classes } = this.props;

    return (
      site.banner_logos.length > 0 &&
        <div className={classnames('logo-banner-container', site.logo_banner_style == 'image' ? 'template-image' : 'template-text')} style={{background: window.LOGO_BANNER_BACKGROUND_COLOUR}}>
          {site.logo_banner_text &&
            <Typography className={classnames('header-label', site.logo_banner_style == 'image' ? 'template-image' : 'template-text')} style={{color: window.LOGO_BANNER_FONT_COLOUR}}>
              {site.logo_banner_text}
            </Typography>
          }
          {site.logo_banner_style == 'image' && site.banner_logos.map((bannerLogo, index) =>
            <NavLink key={index} to={'/collections/' + bannerLogo.collection_slug} className='button-link'>
              <img key={index} src={bannerLogo.logo} className="logo-image" alt={bannerLogo.name} />
            </NavLink>
          )}
          {site.logo_banner_style == 'text' &&
            <React.Fragment>
              {site.banner_logos.map((bannerLogo, index) =>
                <NavLink key={index} to={'/collections/' + bannerLogo.collection_slug} className='button-link'>
                  <Button component="div" role="none" tabIndex={-1} className="button-text" style={{color: window.LOGO_BANNER_FONT_COLOUR}}>
                    {bannerLogo.name}
                  </Button>
                </NavLink>
              )}
              <hr className="divider" />
            </React.Fragment>
          }
        </div>
    )
  }
}

function mapStateToProps(state) {
  return {
    site: state.site.site
  }
}

export default connect(mapStateToProps, null)(LogoBanner);
